import { render } from "./CurrentNews.vue?vue&type=template&id=5d4322d6"
import script from "./CurrentNews.vue?vue&type=script&lang=js"
export * from "./CurrentNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__